module.exports = __webpack_public_path__ + "img/line-columns.6be86cbe.svg";